import s from "./contract-file.module.scss";
import { IconFileText } from "@tabler/icons-react";

export const ContractFile = () => (
	<a
		href={process.env.REACT_APP_STORAGE_URL + "contract.pdf"}
		target="_blank"
		rel="noreferrer"
		download
		className={s.contractFile}
	>
		<span className={s.contractFileIcon}>
			<IconFileText size={24} />
		</span>
		<span className={s.contractFileInfo}>
			<span className={s.contractFileTitle}>Договор с преподавателем</span>
			<span className={s.contractFileMeta}>PDF</span>
		</span>
	</a>
);
